/**
=========================================================
* Trust Cargo - where "the system" starts for whoever is signed in
=========================================================

* Admins start on Users and customers on Messages - the same places sign-in
* sends them. Staff start on the first page of the menu their permissions
* open (utils/permissions). /dashboard used to be the Soft UI template page; it now
* redirects here, so old links and the website's "enter" button land
* somewhere real.
*/

import { Navigate } from "react-router-dom";
import { startPage } from "utils/permissions";

export function systemHome() {
  const role = sessionStorage.getItem("role_id");
  if (!role) return "/authentication/sign-in";
  return startPage();
}

function SystemHome() {
  return <Navigate replace to={systemHome()} />;
}

export default SystemHome;
